import React from 'react';
import { Modal, ModalBody, ModalFooterButtons, ModalHeader, ModalCloseButton } from '@televet/kibble-ui';
import { Prompt } from 'react-router-dom';
import { useBlockedNavigation } from 'shared/hooks/useBlockedNavigation';

interface BlockedNavigationModalProps {
  shouldBlockNavigation: boolean;
  allowedUrls?: string[];
  onOpen: () => void;
  onCancel: () => void;
  onContinue: () => void;
  isOpen: boolean;
}

export const BlockedNavigationModal = ({
  shouldBlockNavigation,
  allowedUrls,
  onOpen,
  onCancel,
  onContinue,
  isOpen,
}: BlockedNavigationModalProps): JSX.Element => {
  const { handleBlockedNavigation, setConfirmedNavigation } = useBlockedNavigation({
    onBlockedCallback: onOpen,
    allowedUrls,
    shouldBlockNavigation,
  });

  const handleContinueButtonClick = (): void => {
    setConfirmedNavigation(true);
    onContinue();
  };

  return (
    <>
      <Prompt when={shouldBlockNavigation} message={handleBlockedNavigation} />
      <Modal size="md" onClose={onCancel} isOpen={isOpen}>
        <ModalHeader>You have unsaved changes</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to navigate away from this page? If you do, your changes will be lost.
        </ModalBody>
        <ModalFooterButtons onCancel={onCancel} onSubmit={handleContinueButtonClick} submitText="Continue" />
      </Modal>
    </>
  );
};
